module.exports = __webpack_public_path__ + "static/media/noodle_bowl.8cbf6d8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GetDish/noodle_bowl.jpg
// module id = 341
// module chunks = 0